export const SET_QUOTATION = 'SET_QUOTATION'

export const SET_TYPE= 'SET_EDITETYPE'